module.exports = __webpack_public_path__ + "img/brand-03.db75478b.png";